import React, { useState } from 'react'
import { Camera } from 'lucide-react'
import useLocaleText from 'components/useLocaleText'
import { ActionButton, IconBlock } from './NavMenu'
import TaskCreationModal from 'components/TasksV2/TaskCreation/TaskCreationModal'
import { FlowSelectDialog } from './FlowSelectDialog'
import CategoryTaskCreation from 'components/TasksV2/TasksCreationPageFlow'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { VM_TASK_FLOW_SELECT_RIDS } from 'constants/baseValues'
import { Text } from '@chakra-ui/core'

interface CreateVMTaskButtonProps {
  setIsHidden?: (value: boolean) => void
}

export const CreateVMTaskButton: React.FC<CreateVMTaskButtonProps> = ({ setIsHidden }) => {
  const rid = useSelector((state: RootState) => state.config.config?.rid)
  const isFlatFlow = VM_TASK_FLOW_SELECT_RIDS.includes(rid)
  const [isFlowSelectOpen, setIsFlowSelectOpen] = useState(false)
  const [isFlowBOpen, setIsFlowBOpen] = useState(false)
  const [isFlowAOpen, setIsFlowAOpen] = useState(false)
  const t_createVMTask = useLocaleText('create_vm_task') || 'Create VM Task'

  const handleOpenFlowSelect = () => {
    if (!isFlatFlow) {
      // Non-live rid: skip flow selection, open Flow A directly
      setIsFlowAOpen(true)
      return
    }
    setIsFlowSelectOpen(true)
    setIsHidden?.(true)
  }

  const handleCloseFlowSelect = () => {
    setIsFlowSelectOpen(false)
    setIsHidden?.(false)
  }

  const handleSelectFlowA = () => {
    setIsFlowSelectOpen(false)
    setIsFlowAOpen(true)
  }

  const handleSelectFlowB = () => {
    setIsFlowSelectOpen(false)
    setIsFlowBOpen(true)
  }

  const handleCloseFlowA = () => {
    setIsFlowAOpen(false)
    setIsHidden?.(false)
  }

  return (
    <>
      <ActionButton onClick={handleOpenFlowSelect}>
        <IconBlock background="#FFF4E6">
          <Camera size={18} color="#FB8C00" />
        </IconBlock>
        <Text fontSize="14px">{t_createVMTask}</Text>
      </ActionButton>

      {isFlatFlow && (
        <FlowSelectDialog
          isOpen={isFlowSelectOpen}
          onClose={handleCloseFlowSelect}
          onSelectFlowA={handleSelectFlowA}
          onSelectFlowB={handleSelectFlowB}
        />
      )}

      {isFlowBOpen && (
        <CategoryTaskCreation
          onClose={() => {
            setIsFlowBOpen(false)
            setIsHidden?.(false)
          }}
        />
      )}
      {isFlowAOpen && <TaskCreationModal isOpen={isFlowAOpen} onClose={handleCloseFlowA} isVmTask={true} />}
    </>
  )
}
